/**
 * AppData is not fully integrated yet, so we use hardcoded hashes to distinguish swap/limit orders
 * TODO: wire up real appData to Solana orders
 */
export const SOLANA_LIMIT_ORDER_STAGING_APP_DATA = '0xd2e88c2a59a536f1efe438267ea1b4efacec60b709eb9cd607b5f2caa9d6f910'
export const SOLANA_LIMIT_ORDER_PROD_APP_DATA = '0x8edb72fc822ff168ce66d6c4ade61567503f644242a62de5b35fbf6ea5560349'
